

import objectDefaultValue from '@/config/object.env'
import handleData2 from '@/store/modules/handleData2'

const newModel = () => {
    return {
        benhVienId: null,
        maDinhDanh: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        tongsoGiuongbenh: null,
        gioiThieu: null,
        web: null,
        email: null,
        ghiChu: null,
        stt: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        benhVienId: null,
        maDinhDanh: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        tongsoGiuongbenh: null,
        gioiThieu: null,
        web: null,
        email: null,
        ghiChu: null,
        stt: "0",
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        benhVienId: item.benhVienId,
        maDinhDanh: item.maDinhDanh,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        tongsoGiuongbenh: item.tongsoGiuongbenh,
        gioiThieu: item.gioiThieu,
        web: item.web,
        email: item.email,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        benhVienId: item.benhVienId,
        maDinhDanh: item.maDinhDanh,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        tongsoGiuongbenh: item.tongsoGiuongbenh,
        gioiThieu: item.gioiThieu,
        web: item.web,
        email: item.email,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        tongsoGiuongbenh: null,
        gioiThieu: null,
        web: null,
        email: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        enabled: null,
    }
}

export const benhVienModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newSearchModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


